import { createContext } from 'react';
import {
  TrackClickFunc,
  TrackEventFunc,
  TrackImpressionFunc,
  TrackPageViewFunc,
} from '@src/@types/analytics';

type AnalyticsContextShape = {
  analyticsInitialized: boolean;
  trackPageView: TrackPageViewFunc;
  trackClick: TrackClickFunc;
  trackEvent: TrackEventFunc;
  trackImpression: TrackImpressionFunc;
};

export const AnalyticsContext = createContext<AnalyticsContextShape>({
  analyticsInitialized: false,
  trackPageView: () => {
    return;
  },
  trackClick: () => {
    return;
  },
  trackEvent: () => {
    return;
  },
  trackImpression: () => {
    return;
  },
});
